/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { TwoFactorChallenge } from './components/TwoFactorChallenge'
import { TwoFactorSetup } from './components/TwoFactorSetup'
import { AuthLayout } from '../../../_metronic/layout/AuthLayout'

export const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path=':empresa/login' element={<Login />} />
      <Route path='confirm-account' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='2fa' element={<TwoFactorChallenge />} />
      <Route path='2fa/cadastro' element={<TwoFactorSetup />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)
